import { Stack, styled } from '@mui/material';
import { ReactNode } from 'react';
import theme from 'styles/theme';
type LayoutProps = {
  children: ReactNode;
};

export const LayoutApp = ({ children }: LayoutProps) => {
  return (
    <Wrapper>
      <Stack flex={1} sx={{ background: theme.colors.white, width: '100%' }} alignItems={'center'}>
        {children}
      </Stack>
    </Wrapper>
  );
};

const Wrapper = styled(Stack)(() => ({
  background: '#e8f0fe',
  minHeight: '100dvh',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1
}));
